import React from 'react'
import MoreEpisodesImage from '../../../assets/img/moreEpisodes@2x.svg'

const MoreEpisodes = () => {
  return <img id="moreEpisodes" src={MoreEpisodesImage} alt="More Episodes" />
}

export default MoreEpisodes
